/**
 * Product tabs: switch panels when tab buttons are clicked.
 * Accessible (ARIA, keyboard). Re-runs on shopify:section:load.
 */
(function () {
  function initTabs(container) {
    if (!container || container._productTabsInit) return;
    container._productTabsInit = true;

    var tabs = container.querySelectorAll('[data-product-tab]');
    var panels = container.querySelectorAll('[data-product-tab-panel]');

    function setActive(tabId) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-product-tab') === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });
      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-product-tab-panel') === tabId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActive(tab.getAttribute('data-product-tab'));
      });
    });
  }

  function run() {
    document.querySelectorAll('.product-tabs').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section && section.classList && section.classList.contains('section-product-tabs')) {
      section._productTabsInit = false;
      initTabs(section);
    }
  });
})();
